import ProductApplicationsTable from './product-applications-table';

class TabsGroup {
    constructor($el) {
        this.$el = $el;
        this.$activeTabTitle = null;
        this.$activeTabContent = null;

        if(this.$el.length) {
            this._findDOMElements();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.focusTabFn = this._focusTab.bind(this);

        this.$tabsTitles.on('click', this.focusTabFn);
    }

    _findDOMElements() {
        this.$tabsTitles = this.$el.find('.tabs-group__tab-title');
        this.tabsContent = {
            'tabs-group__tab-content--specifications': this.$el.find('.tabs-group__tab-content--specifications'),
            'tabs-group__tab-content--applications': this.$el.find('.tabs-group__tab-content--applications'),
            'tabs-group__tab-content--logistic': this.$el.find('.tabs-group__tab-content--logistic'),
            'tabs-group__tab-content--downloads': this.$el.find('.tabs-group__tab-content--downloads'),
            'tabs-group__tab-content--contact': this.$el.find('.tabs-group__tab-content--contact')
        };
    }

    _focusTab(e) {
        this.$activeTabTitle = $(e.currentTarget);

        if(!this.$activeTabTitle.hasClass('tabs-group__tab-title--active')) {
            this.$activeTabContent = this.tabsContent[this.$activeTabTitle.attr('data-tab')];

            if(this.$activeTabContent) {
                const $previouslyActiveTabsTitles = this.$el.find('.tabs-group__tab-title--active');
                const $previouslyActiveTabsContents = this.$el.find('.tabs-group__tab-content--active');

                if($previouslyActiveTabsTitles.length) {
                    $previouslyActiveTabsTitles.removeClass('tabs-group__tab-title--active');
                }
                if($previouslyActiveTabsContents.length) {
                    $previouslyActiveTabsContents.removeClass('tabs-group__tab-content--active');
                }

                this.$activeTabTitle.addClass('tabs-group__tab-title--active');
                this.$activeTabContent.addClass('tabs-group__tab-content--active');

                if(!this.$activeTabTitle.hasClass('tabs-group__tab--loaded')) {
                    let actionName = '';
                    const productId = this.$activeTabTitle[0].hasAttribute('data-product') ? this.$activeTabTitle.attr('data-product') : '';

                    if(this.$activeTabTitle.attr('data-tab') === 'tabs-group__tab-content--applications') {
                        actionName = 'get_applications';
                    }
                    else if(this.$activeTabTitle.attr('data-tab') === 'tabs-group__tab-content--logistic') {
                        actionName = 'get_logistics';
                    }
                    else if(this.$activeTabTitle.attr('data-tab') === 'tabs-group__tab-content--downloads') {
                        actionName = 'get_documents';
                    }
                    // else if($target.hasClass('tabs-group__tab-content--contact')) {}

                    this._loadTab(actionName, productId, this._onTabLoadComplete.bind(this));
                }
            }
        }
    }

    _loadTab(actionName, productId, callback) {
        if(actionName && productId) {
            const request = $.ajax({
                method: 'POST',
                url: cal.ajax_url,
                data: {
                    action: actionName,
                    product_id: productId,
                    nonce: cal.nonce
                }
            });

            request.done((data) => {
                if(callback) {
                    callback(data, actionName);
                }
            });
            request.fail((jqxhr, textStatus, error) => {
                console.log('error', jqxhr, textStatus, error);
            });
        }
    }

    _onTabLoadComplete(data, actionName) {
        if(data.data.return) {
            this.$activeTabTitle.addClass('tabs-group__tab--loaded');
            this.$activeTabContent.find('.loading-indicator').replaceWith(data.data.return);

            if(actionName === 'get_applications') {
                const $productApplicationsTable = this.$activeTabContent.find('.product-applications-table.datatable');

                if($productApplicationsTable.length) {
                    new ProductApplicationsTable($productApplicationsTable);
                }
            }
        }
    }
}

export default TabsGroup;
